import { AppEntityHydrated } from "@jackfruit/common"
import { useSearchParam } from "react-use"

export const usePageDisplayFlags = (appConfig: AppEntityHydrated) => {
  const {
    common: { hideHeader: hideHeaderConfig, hideFooter: hideFooterConfig },
  } = appConfig

  const hideHeaderParam = useSearchParam("hideHeader") === "1"
  const hideFooterParam = useSearchParam("hideFooter") === "1"
  const focusMode = useSearchParam("focusMode") === "1"

  const hideHeader = Boolean(hideHeaderConfig) || hideHeaderParam || focusMode
  const hideFooter = Boolean(hideFooterConfig) || hideFooterParam || focusMode

  return { hideHeader, hideFooter }
}
